import React, { Component } from 'react';
import ContentTools from 'ContentTools/build/content-tools.min.js';
import { get } from 'lodash';
import { initLockTool } from '../../../lib/contenttools/lock';
import { initEventTool } from '../../../lib/contenttools/event';
import { initArtistTool } from '../../../lib/contenttools/artist';
import { initInputField } from '../../../lib/contenttools/input.field';
import { times } from 'lodash';
import { initMediaPartnersTool } from '../../../lib/contenttools/media.partners';
import { initCheckboxTool } from '../../../lib/contenttools/checkbox';
import { imageUploader } from '../../../lib/contenttools/imageUploader';
import { imageFixRTE } from '../../../lib/dom.utils';
import { RT_TYPE_EMAIL, MODELS } from '../../../constants/admin/settings';
import { initRecipientsTool } from '../../../lib/contenttools/recipients';
import { initPartnerTool } from '../../../lib/contenttools/partner';
import { initContractLink } from '../../../lib/contenttools/contract.link';
import { initPincode } from '../../../lib/contenttools/pincode';
import { initMessageTool } from '../../../lib/contenttools/message';
import { initContractContentTool } from '../../../lib/contenttools/contract.content';
import {
    ARTIST_SIGNED_CONTRACT,
    ARTIST_NEW_CONTRACT,
    ARTIST_REMINDER_CONTRACT,
    ARTIST_NEW_PERF_CONTRACT,
    ARTIST_SIGNED_PERF_CONTRACT,
    ARTIST_REMINDER_PERF_CONTRACT
} from '../../../selectors/admin/models/event.emails';
import { cleanRichTextHtml } from '../../../lib/html.utils';
import { initTextOverride } from '../../../lib/contenttools/override.text';

const LOCK_TOOL = 'lock';
const CHECKBOX_TOOL = 'checkbox';
const EVENT_TOOL = 'event';
const ARTIST_TOOL = 'artist';
const RECIPIENTS_TOOL = 'recipients';
const INPUT_FIELD_TOOL = 'input';
const PARTNERS_TOOL = 'partners';
const PARTNER_TOOL = 'partner';
const CONTRACT_LINK_TOOL = 'contractlink';
const PIN_CODE_TOOL = 'pincode';
const MESSAGE_TOOL = 'message';
const CONTRACT_CONTENT_TOOL = 'contractcontent';
const A4_HEIGHT = 1123;

class RichTextEditor extends Component {
    // REACT
    state = { defaultTools: [...ContentTools.DEFAULT_TOOLS] };
    componentDidMount() {
        window.ContentEdit.TRIM_WHITESPACE = false;
        initTextOverride();
        document.addEventListener('keydown', this._keyListener);
        document.addEventListener('keyup', this._keyListener);
        initLockTool();
        initEventTool();
        initArtistTool();
        initMediaPartnersTool();
        initCheckboxTool();
        initInputField();
        initRecipientsTool();
        initPartnerTool();
        initContractLink();
        initPincode();
        initMessageTool();
        initContractContentTool();
        if (ContentTools.DEFAULT_TOOLS.length === 4) {
            ContentTools.DEFAULT_TOOLS[2] = this.isEmail() ? [] : ['image']; // Remove video and preformat from tools

            if (!this.isEmail()) {
                ContentTools.DEFAULT_TOOLS.push([INPUT_FIELD_TOOL]);
                ContentTools.DEFAULT_TOOLS.push([CHECKBOX_TOOL]);
            }
            ContentTools.DEFAULT_TOOLS.push([EVENT_TOOL]);
            if ((this.props.subType || '').toLowerCase().includes(MODELS.PARTNER)) {
                ContentTools.DEFAULT_TOOLS.push([PARTNER_TOOL]);
            } else if ((this.props.subType || '').toLowerCase().includes(MODELS.ARTIST) || !this.props.subType) {
                ContentTools.DEFAULT_TOOLS.push([ARTIST_TOOL]);
            }
            if ((this.props.subType || '').toLowerCase().includes(MODELS.ARTIST)) {
                ContentTools.DEFAULT_TOOLS.push([CONTRACT_LINK_TOOL]);
                ContentTools.DEFAULT_TOOLS.push([PIN_CODE_TOOL]);
            }
            if (
                (this.props.subType || '').toLowerCase().includes('update') ||
                this.props.subType === ARTIST_NEW_CONTRACT ||
                this.props.subType === ARTIST_NEW_PERF_CONTRACT ||
                this.props.subType === ARTIST_REMINDER_CONTRACT ||
                this.props.subType === ARTIST_REMINDER_PERF_CONTRACT
            ) {
                ContentTools.DEFAULT_TOOLS.push([MESSAGE_TOOL]);
            }
            if (this.props.subType === ARTIST_SIGNED_CONTRACT || this.props.subType === ARTIST_SIGNED_PERF_CONTRACT) {
                ContentTools.DEFAULT_TOOLS.push([CONTRACT_CONTENT_TOOL]);
            }
            if (!this.isEmail()) {
                ContentTools.DEFAULT_TOOLS.push([PARTNERS_TOOL]);
                ContentTools.DEFAULT_TOOLS.push([LOCK_TOOL]);
            } else {
                ContentTools.DEFAULT_TOOLS.push([RECIPIENTS_TOOL]);
            }
        }

        ContentTools.IMAGE_UPLOADER = imageUploader;
        ContentTools.CANCEL_MESSAGE = null;

        this.editor = ContentTools.EditorApp.get();

        this.editor.init('[data-editable]', 'editor');
        this.editor.addEventListener('saved', this._saveContent);
        this.editor.addEventListener('tool-applied', this._autoSave);
        this._updatePagination();
    }

    isEmail = () => this.props.type === RT_TYPE_EMAIL;
    shouldComponentUpdate(prevProps) {
        if (prevProps.textTransformTrigger !== this.props.textTransformTrigger) {
            this._transformText();
        }
        return !this.isEditing();
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this._keyListener);
        document.removeEventListener('keyup', this._keyListener);
        ContentTools.DEFAULT_TOOLS = this.state.defaultTools;
        this.editor.destroy();
    }

    _keyListener = () => {
        const element = document.getElementById('ckp-rich-text-editor');
        if (element && !element.innerHTML) {
            element.innerHTML = '';
        }
        this._updatePagination();
    };
    _updatePagination = () => {
        const editor = document.getElementById('ckp-rich-text-editor');
        const editorParent = editor && editor.parentElement;
        if (this.props.paginated && editorParent) {
            const removeElements = elms => elms.forEach(el => el.remove());
            removeElements(document.querySelectorAll('.ckp-rich-text-editor-page-separator'));
            const totalPages = Math.floor(editorParent.clientHeight / A4_HEIGHT);
            if (editorParent.clientHeight > A4_HEIGHT) {
                times(totalPages, i => {
                    const pageSeparator = document.createElement('span');
                    pageSeparator.className = 'ckp-rich-text-editor-page-separator';
                    pageSeparator.style = `top: ${(i + 1) * 1123}px`;
                    editorParent.append(pageSeparator);
                });
            }
        }
    };
    // EDITOR PUBLIC
    start = () => {
        this.editor.start();
        this._toggleEditableContent(true);
        this._updatePagination();
        setTimeout(this._cleanUp, 200);
    };
    stopWithSaving = () => {
        this.editor.stop(true);
        this._updatePagination();
        setTimeout(this._cleanUp, 200);
    };
    stopWithoutSaving = () => {
        this.editor.stop(false);
        this._updatePagination();
        setTimeout(this._cleanUp, 200);
    };
    setContent = (content, skipCleanup = false) => {
        if (this.isEditing()) {
            content = imageFixRTE(content);
            this.editor.regions()[0] && this.editor.regions()[0].setContent(content);
        } else {
            const element = document.getElementById('ckp-rich-text-editor');
            if (element) {
                element.innerHTML = content;
            }
        }
        this._updatePagination();
        !skipCleanup && this._cleanUp();
    };
    getContent = () => get(this.editor.regions(), '[0]._domElement.innerHTML');
    isEditing = () => (this.editor && this.editor.getState()) === 'editing';

    // EDITOR PRIVATE
    _cleanUp = () => {
        cleanRichTextHtml('ckp-rich-text-editor', true);
        if (!this.isEditing()) {
            this._toggleEditableContent(false);
        }
        if (!document.getElementById('ckp-rich-text-editor').innerHTML) {
            this.setContent('', true);
        }
    };
    _toggleEditableContent = on => {
        if (on) {
            this.setContent(this.getContent().replace(/content_editable/g, 'contenteditable'));
        } else {
            document.getElementById('ckp-rich-text-editor').innerHTML = document
                .getElementById('ckp-rich-text-editor')
                .innerHTML.replace(/contenteditable/g, 'content_editable')
                .replace(/ce-element--focused/g, '')
                .replace(/ce-element--empty/g, '');
        }
        // this.props.setCommentListeners && this.props.setCommentListeners();
    };
    _saveContent = _ => {
        this.props.onSave(document.getElementById('ckp-rich-text-editor').innerHTML);
    };
    _transformText = () => {
        const richText = !this.isEditing() ? this.props.data : this.getContent();
        return this.props.textTransformFunction && richText && this.props.textTransformFunction(this, richText);
    };
    _autoSave = e => {
        if (get(e, '_detail.transform')) {
            this._transformText();
        }
        if (this.props.autoSave) {
            this._cleanUp();
            this.editor.save(true);
        }
    };
    _createMarkup = () => ({
        __html: `<div data-editable class="ckp-rich-text-content" id="ckp-rich-text-editor" data-name="editor">${this
            .props.data || '<p></p>'}</div>`
    });
    render() {
        this._updatePagination();
        return (
            <div
                onKeyUp={this._autoSave}
                tabIndex={0}
                className={this.props.className}
                dangerouslySetInnerHTML={this._createMarkup()}
            />
        );
    }
}

export default RichTextEditor;



// WEBPACK FOOTER //
// ./src/components/admin/forms/RichTextEditor.js